import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { LogInResponse } from '../models/user.model';

import * as jwtDecode from 'jwt-decode';

@Injectable()
export class UserService {
    private warrantServiceURL: string = environment.WMS_Service_URL;

    constructor(private httpclient: HttpClient) { }

    logIn(username: string, password: string): Observable<LogInResponse> {
        let url = this.warrantServiceURL + "api/Authentication/LoginAsync";
        let header = new HttpHeaders({ 'Content-Type': 'application/json' });
        let model = { "userName": username, "password": password }

        return this.httpclient.post<LogInResponse>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    GoogleLogin(idToken: string): Observable<LogInResponse> {
        let url = this.warrantServiceURL + "api/Authentication/GoogleLoginAsync";
        let header = new HttpHeaders({ 'Content-Type': 'application/json' });
        let model = { "IDToken": idToken }

        return this.httpclient.post<LogInResponse>(url, model, {
            headers: header
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }


    getUser() {
        if (sessionStorage.getItem("token") === null) {
            return;
        }

        let decoded = jwtDecode(sessionStorage.getItem("token"));
        if (!decoded) {
            return;
        }

        return {
            username: decoded.LoginName,
            screenCode: decoded.ScreenCode
        }
    }

    isUserLoggedIn() {
        return !!this.getUser();
    }

    private handleError(error: Response | any): Observable<any> {
        // In a real world app, we might use a remote logging infrastructure
        if (error instanceof Response) {
            // const body = error.json() || '';
            // const err = body.error || JSON.stringify(body);
            // errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            console.error(error);
            return Observable.throw(error);
        } else {
            let errMsg: string;
            errMsg = error.message ? error.message : error.toString();
            console.error(errMsg);
            return Observable.throw(errMsg);
        }
    }
}